import { render, staticRenderFns } from "./electricData.vue?vue&type=template&id=67cd2140&scoped=true&"
import script from "./electricData.vue?vue&type=script&lang=js&"
export * from "./electricData.vue?vue&type=script&lang=js&"
import style0 from "./electricData.vue?vue&type=style&index=0&id=67cd2140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cd2140",
  null
  
)

export default component.exports